<template>
    <div class="data-list__checkbox">
        <checkbox :value="checkboxValue" :size="checkboxSize" />
        <div class="data-list__checkbox--text">
            <slot />
        </div>
    </div>
</template>

<script>
import Checkbox from '@/components/utilities/checkbox';

export default {
    name: 'data-list-item',

    components: {
        Checkbox,
    },

    props: {
        checkboxValue: {
            type: Boolean,
            required: true,
        },

        checkboxSize: {
            type: String,
            default: '2x',
        },
    },
};
</script>
